import { Injectable } from '@angular/core';

declare var google;
declare var googleLoadedFlag;

@Injectable()
export class GoogleMapsService {
  private geocoder;
  private map;

  constructor() {
    this.init();
  }

  init() {
    if (googleLoadedFlag) {
      this.geocoder = new google.maps.Geocoder();
    }
  }

  // Will create a google map placed at 'element', with center and marker on 'address'
  loadMapWithLocation(element, address, title, errorCallback) {
    if (googleLoadedFlag) {
      if (!this.geocoder) {
        this.geocoder = new google.maps.Geocoder();
      }
      this.geocoder.geocode({'address': address}, (results, status) => {
        if (status === 'OK') {
          let mapOptions = {
            center: results[0].geometry.location,
            zoom: 15,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            disableDefaultUI: true
          };

          this.map = new google.maps.Map(element, mapOptions);

          // Place the marker
          let marker = new google.maps.Marker({
            map: this.map,
            position: results[0].geometry.location,
            icon: './assets/marker.png'
          });

          // Search for this place id if there is any
          let placeRequest = {
            location: this.map.getCenter(),
            radius: '500',
            query: title
          };

          let service = new google.maps.places.PlacesService(this.map);
          service.textSearch(placeRequest, (placeResults, status) => {
            let infowindow;
            let infowindowContentA = 
              `<div style="font-family: 'Roboto', sans-serif; font-size: 13px;">
                  <span style="font-weight: 500; font-size: 14px;">${title}</span><br>
                  ${address}<br><br>`;
            let infowindowContentB = 
              `<a href="https://www.google.com/maps/search/?api=1&query=${results[0].geometry.location.lat()},${results[0].geometry.location.lng()}" 
                  target="_blank">Ver en Google Maps</a></div>`;
            if (status == google.maps.places.PlacesServiceStatus.OK) {
              service.getDetails({placeId: placeResults[0].place_id}, (place, status) => {
                if (status == google.maps.places.PlacesServiceStatus.OK) {
                  infowindow = new google.maps.InfoWindow({
                    content: infowindowContentA + `<a href="${place.url}" target="_blank">Ver en Google Maps</a></div>`
                  });
                } else {
                  infowindow = new google.maps.InfoWindow({
                    content: infowindowContentA + infowindowContentB
                  });
                }
                
                marker.addListener('click', () => {
                  this.map.setCenter(marker.getPosition());
                  infowindow.open(this.map, marker);
                });
              });
            } else {
              infowindow = new google.maps.InfoWindow({
                content: infowindowContentA + infowindowContentB
              });
              marker.addListener('click', () => {
                this.map.setCenter(marker.getPosition());
                infowindow.open(this.map, marker);
              });
            }
          });
        } else {
          errorCallback();
        }
      });
    }
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/services/google-maps-service.ts